import { createQueryFn } from '@oneview/redux/utils';
import { api } from './baseApi';

export const tipranksApi = api.injectEndpoints({
    endpoints: (build) => ({
        getTipranksAnalystRatingsBySymbol: build.query({
            queryFn: createQueryFn(async (symbols: string[], { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAnalystRatingsBySymbol(symbols, 30);
            }),
        }),
        getTipranksAssetsOverview: build.query({
            queryFn: createQueryFn(async ({ symbols }: { symbols: string[] }, { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAssetsOverview(symbols);
            }),
        }),
        getTipranksAnalystProfile: build.query({
            queryFn: createQueryFn(async (id: string, { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAnalystProfile(id);
            }),
        }),
        getTipranksAnalystPortfolio: build.query({
            queryFn: createQueryFn(async (expertUID: string, { extra: api }) => {
                return api.orbisMiddleware.tipranks.getTipranksAnalystPortfolio(expertUID);
            }),
        }),
    }),
});

export const {
    useGetTipranksAnalystRatingsBySymbolQuery,
    useGetTipranksAssetsOverviewQuery,
    useGetTipranksAnalystProfileQuery,
    useGetTipranksAnalystPortfolioQuery,
} = tipranksApi;
